import React from "react";
import { Box, Container, Typography, Stack } from "@mui/material";
import { motion } from "framer-motion";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const PURPLE = "#7C3AED";
const BG     = "#030014";
const BG2    = "#0F0728";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";
const R      = "14px";

const ProcessTimeline = ({ title, subtitle, steps }) => (
  <Box id="process" sx={{ py: { xs: 10, md: 13 }, borderBottom: `1px solid ${LINE}`, background: BG }}>
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
        viewport={{ once: true }}
      >
        <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 1.75, textAlign: "center" }}>
          {subtitle || "Our Process"}
        </Typography>
        <Typography sx={{
          fontFamily: "'IBM Plex Serif', serif",
          fontSize: { xs: "1.75rem", md: "2.5rem" },
          fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
          color: INK, maxWidth: 720, mx: "auto", mb: 8, textAlign: "center",
        }}>
          {title}
        </Typography>
      </motion.div>

      <Box sx={{ position: "relative" }}>
        {/* Horizontal connector line */}
        <Box sx={{
          display: { xs: "none", md: "block" },
          position: "absolute", top: "38px",
          left: "calc(12.5% + 22px)", right: "calc(12.5% + 22px)",
          height: "1px",
          background: `linear-gradient(90deg, ${ACCENT}66 0%, ${PURPLE}66 50%, ${ACCENT}66 100%)`,
        }} />

        <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 3, md: 2 }} justifyContent="space-between">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.12 }}
              viewport={{ once: true }}
              style={{ flex: 1 }}
            >
              <Box sx={{ textAlign: "center", px: 1.5 }}>
                {/* Step number circle */}
                <Box sx={{
                  width: 52, height: 52, borderRadius: "50%",
                  background: `linear-gradient(135deg, ${ACCENT}, ${PURPLE})`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  mx: "auto", mb: 2.5, position: "relative", zIndex: 1,
                  boxShadow: `0 0 20px ${ACCENT}60`,
                  border: "2px solid rgba(255,255,255,0.08)",
                }}>
                  <Typography sx={{ color: "white", fontWeight: 700, fontFamily: MONO, fontSize: "14px" }}>
                    {String(index + 1).padStart(2, "0")}
                  </Typography>
                </Box>

                <Typography sx={{ fontWeight: 600, color: INK, mb: 1, fontSize: "16px" }}>
                  {step.title}
                </Typography>
                <Typography sx={{ color: INK2, fontSize: "14px", lineHeight: 1.7, maxWidth: "220px", mx: "auto" }}>
                  {step.description}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Stack>
      </Box>
    </Container>
  </Box>
);

export default ProcessTimeline;
